/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {ContactDto} from "./contactDto.zod";
import {HeliportEnvironment} from "./heliportEnvironment.zod";
import {LeadState} from "./leadState.zod";
import {NoteDto} from "./noteDto.zod";
import {UnregisteredCompanyDto} from "./unregisteredCompanyDto.zod";

export const LeadDto = zod.object({
  leadId: zod.uuid(),
  state: LeadState,
  createdAt: zod.iso.datetime({offset: true}),
  updatedAt: zod.iso.datetime({offset: true}),
  deletedAt: zod.iso.datetime({offset: true}).nullable(),
  company: UnregisteredCompanyDto,
  environments: zod.array(HeliportEnvironment).min(1),
  logoUrl: zod.string().nullable(),
  contacts: zod.array(ContactDto),
  notes: zod.array(NoteDto),
});

export type LeadDto = zod.input<typeof LeadDto>;
export type LeadDtoOutput = zod.output<typeof LeadDto>;
